(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 32925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60098);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78239);
/* harmony import */ var _404_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4451);
/* harmony import */ var _404_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_404_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var Page404 = function Page404() {
  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_404_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["not-found-container"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    className: (_404_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["not-found-title"])
  }, "404"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", {
    className: (_404_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["not-found-subtitle"])
  }, t("page404")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
    rootTagName: "a",
    href: "/",
    className: (_404_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["not-found-button"])
  }, t("goToMainPage")));
}; // need server side module because it's a separate page


var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page404);

/***/ }),

/***/ 90392:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(32925);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4451:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","not-found-title":"__404_not-found-title__sUfl9","not-found-subtitle":"__404_not-found-subtitle__ZgBEA","not-found-container":"__404_not-found-container___XAuJ","not-found-button":"__404_not-found-button__01SGI"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [218,239,888,774,179], function() { return __webpack_exec__(90392); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);